import { render, staticRenderFns } from "./EditTagModal.vue?vue&type=template&id=72884662"
import script from "./EditTagModal.vue?vue&type=script&lang=js"
export * from "./EditTagModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports